import {
  hotelCampaignProviderImportStatuses,
  hotelCampaignRegistrationStatuses
} from 'main/hotelStatuses'

/**
 *
 * @typedef Hotel
 * @property {string} hotelName
 * @property {string} bookingEngine
 * @property {string} chainCode
 * @property {string} parentChainCode
 * @property {string} textMarketingUrlKey
 * @property {string} addedOn
 * @property {number} addedBy
 * @property {string} updatedOn
 * @property {number} updatedBy
 * @property {string} id
 * @property {number} numberOfRooms
 * @property {string} pms
 * @property {boolean} isMissingSomeInformation
 * @property {number} displayId
 * @property {boolean} isDeleted
 * @property {number} status
 * @property {object[]} subsidiaryPmsUsers
 * @property {number} subsidiaryPmsUsers.id
 * @property {string} subsidiaryPmsUsers.subsidiaryId
 * @property {string} subsidiaryPmsUsers.email
 * @property {string} subsidiaryPmsUsers.firstName
 * @property {string} subsidiaryPmsUsers.lastName
 * @property {string} subsidiaryPmsUsers.birthDate
 * @property {string} subsidiaryPmsUsers.addedOn
 * @property {number} subsidiaryPmsUsers.addedBy
 * @property {string} merchantName
 * @property {object[]} inviteBlockOn
 * @property {string} inviteBlockOn.addedBy
 * @property {string} inviteBlockOn.addedOn
 * @property {string} inviteBlockOn.reason
 * @property {boolean} pmsSyncIsConnected
 * @property {boolean} isServiceStarted
 * @property {boolean} isCampaignsEnabled
 * @property {boolean} isTcrActivated
 * @property {boolean} isPhoneEnabled
 * @property {object[]} tags
 * @property {number} tags.id
 * @property {string} tags.name
 * @property {string} tags.addedBy
 * @property {string} tags.addedOn
 * @property {string} processKind
 *
 */

/**
 *
 * @param {Hotel[]} hotels
 * @param {String} selectedParentChain
 * @param {String} selectedGroup
 * @param {String} selectedStatus
 * @returns
 */
export function filterByGroupAndParentChain(
  hotels,
  selectedParentChain,
  selectedGroup,
  selectedStatus
) {
  if (hotels) {
    return hotels
      .filter(h => !!h.parentChainCode)
      .filter(h =>
        selectedParentChain === 'all' ? true : h.parentChainCode === selectedParentChain
      )
      .filter(h => (selectedGroup === 'all' ? true : `${h.name}` === selectedGroup))
      .filter(h => {
        if (selectedStatus.length === 0) {
          return true
        } else if (hotelCampaignRegistrationStatuses.includes(h.status)) {
          return selectedStatus.includes('PendingCampaignBrandRegistration')
        } else if (hotelCampaignProviderImportStatuses.includes(h.status)) {
          return selectedStatus.includes('PendingCampaignProviderImport')
        } else {
          return selectedStatus.includes(h.status)
        }
      })
  }

  return []
}

/**
 *
 * @param {Hotel[]} hotels
 * @param {String} selectedParentChain
 * @param {String} selectedGroup
 * @param {String} selectedStatus
 * @returns
 */
export function filterByGroupAndChain(
  hotels,
  selectedChain,
  selectedGroup,
  selectedStatus
) {
  if (hotels) {
    return hotels
      .filter(h => !!h.parentChainCode)
      .filter(h => (selectedChain === 'all' ? true : h.chainCode === selectedChain))
      .filter(h => (selectedGroup === 'all' ? true : `${h.name}` === selectedGroup))
      .filter(h => {
        if (selectedStatus.length === 0) {
          return true
        } else if (hotelCampaignRegistrationStatuses.includes(h.status)) {
          return selectedStatus.includes('PendingCampaignBrandRegistration')
        } else if (hotelCampaignProviderImportStatuses.includes(h.status)) {
          return selectedStatus.includes('PendingCampaignProviderImport')
        } else {
          return selectedStatus.includes(h.status)
        }
      })
  }

  return []
}

/**
 *
 * @param {Hotel[]} hotels
 * @param {String} selectedParentChain
 * @param {String} selectedGroup
 * @param {String} selectedStatus
 * @returns
 */
export function filterByChainAndParentChain(
  hotels,
  selectedChain,
  selectedParentChain,
  selectedStatus
) {
  if (hotels) {
    return hotels
      .filter(h =>
        selectedParentChain === 'all' ? true : h.parentChainCode === selectedParentChain
      )
      .filter(h => (selectedChain === 'all' ? true : h.chainCode === selectedChain))
      .filter(h => {
        if (selectedStatus.length === 0) {
          return true
        } else if (hotelCampaignRegistrationStatuses.includes(h.status)) {
          return selectedStatus.includes('PendingCampaignBrandRegistration')
        } else if (hotelCampaignProviderImportStatuses.includes(h.status)) {
          return selectedStatus.includes('PendingCampaignProviderImport')
        } else {
          return selectedStatus.includes(h.status)
        }
      })
  }

  return []
}
